import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  updateProfile,
  getAllStates,
  getViewProfile,
} from "../../../redux/slices/profileSlice";

const PreferredStatesModal = ({
  show,
  onHide,
  value = [],
  shouldUpdateProfile = false,
  onSave,
  isApplyPage = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);
  console.log(store, "store");

  const [selectedStates, setSelectedStates] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [error, setError] = useState("");

  /* ---------------- FETCH STATES ---------------- */
  useEffect(() => {
    dispatch(getAllStates());
  }, [dispatch]);
  // useEffect(() => {
  //   if (!show) return;
  //   dispatch(getViewProfile());
  // }, [dispatch, show]);

  /* ---------------- MAP STATES TO DROPDOWN ---------------- */
  useEffect(() => {
    if (store?.stateItems?.data?.states) {
      const options = store.stateItems.data.states.map((state) => ({
        value: state.state,
        label: state.state_full_name,
      }));

      setStateOptions(options);
    }
  }, [store?.stateItems]);

  /* ---------------- LOAD EXISTING SELECTED STATES ---------------- */
  // useEffect(() => {
  //   if (!show) return;

  //   const current =
  //     store?.profileItem?.data?.nurseProfile?.preferred_relocation_states || [];

  //   if (!current.length) {
  //     setSelectedStates([]);
  //     return;
  //   }

  //   const formatted = current.map((stateCode) => {
  //     const match = stateOptions.find((opt) => opt.value === stateCode);

  //     return match
  //       ? match
  //       : {
  //           value: stateCode,
  //           label: stateCode,
  //         };
  //   });

  //   setSelectedStates(formatted);
  // }, [show, store?.profileItem, stateOptions]);

  useEffect(() => {
    if (!show) return;

    if (isApplyPage) {
      // ✅ APPLY MODE
      const formatted = value
        .map((code) => stateOptions.find((opt) => opt.value === code))
        .filter(Boolean);

      setSelectedStates(formatted);
    } else {
      // ✅ PROFILE MODE
      const current =
        store?.profileItem?.data?.nurseProfile?.preferred_relocation_states ||
        [];

      const formatted = current.map((code) => {
        const match = stateOptions.find((opt) => opt.value === code);
        return match || { value: code, label: code };
      });

      setSelectedStates(formatted);
    }

    // ❗ ONLY depend on show + stateOptions
  }, [show, stateOptions]);

  /* ---------------- SAVE ---------------- */
  const handleSave = () => {
    if (!selectedStates.length) {
      setError("Please select at least one state");
      return;
    }

    const values = selectedStates.map((item) => item.value);

    if (isApplyPage) {
      // ✅ ALWAYS update local
      onSave(values);

      // 🔥 ONLY call API if empty before
      if (shouldUpdateProfile) {
        const formData = new FormData();

        formData.append(
          "name",
          store?.profileItem?.data?.name ||
            store?.profileItem?.data?.full_name ||
            "",
        );

        formData.append("preferred_states", JSON.stringify(values));

        dispatch(updateProfile(formData));
      }

      onHide();
    } else {
      // ✅ Profile page → always API
      const formData = new FormData();

      formData.append(
        "name",
        store?.profileItem?.data?.name ||
          store?.profileItem?.data?.full_name ||
          "",
      );

      formData.append("preferred_states", JSON.stringify(values));

      dispatch(updateProfile(formData));
    }
  };
  // const handleSave = () => {
  //   if (!selectedStates.length) {
  //     setError("Please select at least one state");
  //     return;
  //   }

  //   const values = selectedStates.map((item) => item.value);

  //   if (isApplyPage) {
  //     // ✅ LOCAL
  //     onSave(values);
  //     onHide();
  //   } else {
  //     // ✅ API
  //     const formData = new FormData();

  //     formData.append(
  //       "name",
  //       store?.profileItem?.data?.name ||
  //         store?.profileItem?.data?.full_name ||
  //         "",
  //     );

  //     formData.append("preferred_states", JSON.stringify(values));

  //     dispatch(updateProfile(formData));
  //   }
  // };
  /* ---------------- CLOSE AFTER SAVE ---------------- */
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Select Preferred States</h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="form-group">
          <Form.Label className="col-label">Preferred States</Form.Label>

          <Select
            options={stateOptions}
            value={selectedStates}
            onChange={(options) => {
              setSelectedStates(options || []);
              setError("");
            }}
            isMulti
            menuPosition="fixed"
            menuPortalTarget={document.body}
            styles={{
              menu: (base) => ({
                ...base,
                borderRadius: "15px",
                marginTop: "8px",
                backgroundColor: "var(--mmp-surface)",
                padding: "6px",
                zIndex: "1000",
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
              option: (base, state) => ({
                ...base,
                borderRadius: "8px",
                padding: "10px",
                backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                color: "var(--mmp-text-primary)",
                cursor: "pointer",
                "&:active": {
                  backgroundColor: "var(--mmp-hover-bg)",
                },
              }),
              multiValue: (base) => ({
                ...base,
                backgroundColor: "var(--mmp-accent-bg)",
                border: "1px solid var(--mmp-accent-border)",
                borderRadius: "6px",
              }),
              multiValueLabel: (base) => ({
                ...base,
                color: "var(--mmp-accent-hover)",
              }),
              multiValueRemove: (base) => ({
                ...base,
                color: "var(--mmp-accent-hover)",
                "&:hover": {
                  backgroundColor: "var(--mmp-danger-bg)",
                  color: "var(--mmp-danger)",
                },
              }),
            }}
            placeholder="Select states..."
            className="react-select-container"
            classNamePrefix="react-select"
          />
        </Form.Group>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || selectedStates.length === 0}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PreferredStatesModal;
